import { useVoiceSettingsQuery } from 'v2/api-console/voice/voice-settings/queries'
import { useUserPlan } from 'v2/shared/hooks/use-plan'

export const useVoiceAccessGate = () => {
  const query = useVoiceSettingsQuery()

  return {
    isChecking: query.isLoading,
    isGated: query.isError || query.data?.voice_enabled === false,
  }
}

/**
 * `voice_enabled === true` grants outright; anything else defers to the plan gate.
 * Grant-only, so it can never lock what works today.
 *
 * `isEnterpriseLocked` not `isEnterprisePlan`: a positive Enterprise test would
 * revoke Endpoints from grandfathered pre-cutoff orgs. `=== true` because the value
 * comes from an untyped upstream blob.
 */
export const deriveVoiceFeatureLock = (args: {
  voiceEnabled: boolean | undefined
  isEnterpriseLocked: boolean
}): boolean => args.voiceEnabled !== true && args.isEnterpriseLocked

/**
 * Shared by the page and the popover nav item so they cannot disagree. Wait on
 * `isVoiceLockLoaded`: both inputs read unlocked in flight, so an entitled account
 * would otherwise flash the CTA.
 */
export const useVoiceFeatureLock = () => {
  const query = useVoiceSettingsQuery()
  const { isEnterpriseLocked, isPlanLoaded } = useUserPlan()

  return {
    isVoiceFeatureLocked: deriveVoiceFeatureLock({
      voiceEnabled: query.data?.voice_enabled,
      isEnterpriseLocked,
    }),
    isVoiceLockLoaded: isPlanLoaded && !query.isLoading,
  }
}
